import { Filter } from "components/Filters";
import { ContractDetailsShipFromFilter } from "./ContractDetailsShipFromFilter";
import { ContractDetailsShipToFilter } from "./ContractDetailsShipToFilter";
import { ContractDetailsModeFilter } from "./ContractDetailsModeFilter";

const contractDetailsOrdersFilters: Filter[] = [
  { key: "shipFrom", component: ContractDetailsShipFromFilter },
  { key: "shipTo", component: ContractDetailsShipToFilter },
  { key: "mode", component: ContractDetailsModeFilter },
];

export default contractDetailsOrdersFilters;
